import React, { createContext, useEffect, useState } from "react";
import { FinancialConvo } from "./models/FinancialConvo";
import { useAuthContext } from "./AuthContextWrapper";
import { SCREEN_PATHS } from "./constants";
import { financialConvoApi } from "./apis";
import { useNavigate } from "react-router-dom";
import { financialConvoFlow } from "./views/flows";
interface Props {
  children: JSX.Element;
}

export interface FinancialConvoContextInterface {
  allFinancialConvos?: FinancialConvo[];
  setAllFinancialConvos?: (financialConvos?: FinancialConvo[]) => void;
  latestFinancialConvo?: FinancialConvo;
  setLatestFinancialConvo?: (financialConvo?: FinancialConvo) => void;
  successfulSubmission?: boolean;
  setSuccessfulSubmission?: (successfulSubmission?: boolean) => void;
  fetchFinancialConvos?: (redirect?: boolean) => void;
}

export const FinancialConvoContext =
  createContext<FinancialConvoContextInterface>({
    allFinancialConvos: undefined,
    setAllFinancialConvos: () => undefined,
    latestFinancialConvo: undefined,
    setLatestFinancialConvo: () => undefined,
    successfulSubmission: undefined,
    setSuccessfulSubmission: () => undefined,
    fetchFinancialConvos: () => undefined,
  });

export const FinancialConvoContextWrapper = ({
  children,
}: Props): JSX.Element => {
  const navigate = useNavigate();
  const { user, setShowContent, activeEstate } = useAuthContext()
  const [allFinancialConvos, setAllFinancialConvos] = useState<
    FinancialConvo[] | undefined
  >(undefined);
  const [latestFinancialConvo, setLatestFinancialConvo] = useState<
    FinancialConvo | undefined
  >(undefined);
  const [successfulSubmission, setSuccessfulSubmission] = useState<
    boolean | undefined
  >(false);

  useEffect(() => {
    (async () => {
      if (latestFinancialConvo === undefined) {
        console.log("fetching financial convos and redirecting to flow")
        await fetchFinancialConvos(true);
      }
    })();
  }, [user]);

  const fetchFinancialConvos = async (redirect?: boolean): Promise<void> => {
    if (!activeEstate?.id || !user?.id) {
      return
    }

    const fetchedConvos = await financialConvoApi.fetchRequests(activeEstate.id, user.id, false, true);
    setAllFinancialConvos(fetchedConvos);

    const latestConvo = await financialConvoApi.fetchLatestRequest(activeEstate.id, user.id, false, true);
    setLatestFinancialConvo(latestConvo);

    if (redirect) {
      const alreadyInFlow = location.pathname.includes(SCREEN_PATHS.flow, 0);

      if (
        !alreadyInFlow ||
        !fetchedConvos ||
        fetchedConvos.length == 0 ||
        !latestConvo ||
        latestConvo.hasCompletedRequest
      ) {
        setTimeout(() => {
          navigate(financialConvoFlow.getFlowFirstScreen());
        }, 0);
      }
      setShowContent(true);
    }
  };

  return (
    <FinancialConvoContext.Provider
      value={{
        allFinancialConvos,
        setAllFinancialConvos,
        latestFinancialConvo,
        setLatestFinancialConvo,
        successfulSubmission,
        setSuccessfulSubmission,
        fetchFinancialConvos,
      }}
    >
      {children}
    </FinancialConvoContext.Provider>
  );
};
